<template>
    <div class="main-view">
        <Map />
    </div>
</template>

<script setup lang="ts">
    import Map from '@/components/map/Map.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { onBeforeMount } from 'vue';

    onBeforeMount(async () => {
        await Promise.all([landPlotStore.LOAD_LAND_PLOTS()]);
    });
</script>

<style lang="less">
    .main-view {
        position: relative;
        overflow-x: clip;
    }
</style>
